import parksIcon from "./images/parks.svg"
import cultureIcon from "./images/culture.svg"
import restaurantsIcon from "./images/restaurants.svg"
import transportIcon from "./images/transport.svg"
import schoolsIcon from "./images/schools.svg"
import parksSmallIcon from "./images/parks-small.svg"
import cultureSmallIcon from "./images/culture-small.svg"
import restaurantsSmallIcon from "./images/restaurants-small.svg"
import transportSmallIcon from "./images/transport-small.svg"
import schoolsSmallIcon from "./images/schools-small.svg"
import parksLargeIcon from "./images/parks-large.svg"
import cultureLargeIcon from "./images/culture-large.svg"
import restaurantsLargeIcon from "./images/restaurants-large.svg"
import transportLargeIcon from "./images/transport-large.svg"
import schoolsLargeIcon from "./images/schools-large.svg"

const categories = [
  {
    name: "Parks and Green Spaces",
    color: "#27ae60",
    icon: parksIcon,
    smallIcon: parksSmallIcon,
    largeIcon: parksLargeIcon,
    locations: [
      {
        name: "Hackney Marshes",
        coordinates: [51.55794, -0.03118],
        distances: [21, 9, 12]
      },
      {
        name: "Coronation Gardens",
        coordinates: [51.55942, -0.01086],
        distances: [3, 1, 1]
      },
      {
        name: "Leyton Jubilee Park",
        coordinates: [51.56298, -0.02424],
        distances: [8, 2, 0]
      },
      {
        name: "Leyton Flats",
        coordinates: [51.58022, 0.01157],
        distances: [54, 16, 23]
      },
      {
        name: "Hollow Ponds",
        coordinates: [51.58039, 0.01013],
        distances: [43, 16, 31]
      },
      {
        name: "Lee Valley Park",
        coordinates: [51.5721, -0.05705],
        distances: [36, 11, 30]
      },
      {
        name: "Abbotts Park",
        coordinates: [51.57114, -0.00688],
        distances: [20, 7, 11]
      },
      {
        name: "Lee Valley Hockey & Tennis Centre",
        coordinates: [51.55303, -0.01591],
        distances: [13, 5, 11]
      },
      {
        name: "SideOut Beach @ Leyton Beach Volley Court",
        coordinates: [51.56005, -0.01415],
        distances: [10, 2, 10]
      },
      {
        name: "Walthamstow Wetlands, London Wildlife Trust",
        coordinates: [51.58547, -0.05418],
        distances: [59, 15, 30]
      },
      {
        name: "WaterWorks Centre Nature Reserve & Filter Beds",
        coordinates: [51.5648, -0.03585],
        distances: [25, 8, 25]
      },
      {
        name: "Jack Cornwell Park",
        coordinates: [51.56981, -0.01184],
        distances: [19, 6, 15]
      },
      {
        name: "Drapers Field Recreation Ground",
        coordinates: [51.55111, -0.00462],
        distances: [19, 6, 12]
      },
      {
        name: "Oliver Road Allotments",
        coordinates: [51.56068, -0.01799],
        distances: [5, 1, 0]
      }
    ]
  },
  {
    name: "Cultural",
    color: "#f1c40f",
    icon: cultureIcon,
    smallIcon: cultureSmallIcon,
    largeIcon: cultureLargeIcon,
    locations: [
      {
        name: "Leyton Orient FC",
        coordinates: [51.56018, -0.01266],
        distances: [2, 1, 0]
      },
      {
        name: "Queen Elizabeth Olympic Park",
        coordinates: [51.54419, -0.0159],
        distances: [11, 4, 9]
      },
      {
        name: "Town Hall",
        coordinates: [51.59115, -0.0136],
        distances: [7, 3, 7]
      },
      {
        name: "Leyton County Cricket Ground",
        coordinates: [51.56742, -0.01031],
        distances: [3, 4, 9]
      },
      {
        name: "Walthamstow Marshes",
        coordinates: [51.56839, -0.04789],
        distances: [59, 15, 30]
      },
      {
        name: "Hackney Marshes",
        coordinates: [51.55794, -0.03118],
        distances: [21, 9, 12]
      },
      {
        name: "London Aquatics Centre",
        coordinates: [51.54018, -0.01055],
        distances: [36, 11, 21]
      },
      {
        name: "Velodrome",
        coordinates: [51.55042, -0.01526],
        distances: [23, 8, 17]
      },
      {
        name: "ArcelorMittal Orbit",
        coordinates: [51.53831, -0.01284],
        distances: [39, 11, 24]
      }
    ]
  },
  {
    name: "Restaurants",
    color: "#c0392b",
    icon: restaurantsIcon,
    smallIcon: restaurantsSmallIcon,
    largeIcon: restaurantsLargeIcon,
    locations: [
      {
        name: "Francis Road",
        coordinates: [51.56364, -0.00554],
        distances: [10, 4, 5]
      },
      {
        name: "High Road Leyton",
        coordinates: [51.56298, -0.01077],
        distances: [5, 3, 3]
      },
      {
        name: "Host of Leyton",
        coordinates: [51.56999, -0.008],
        distances: [17, 5, 11]
      },
      {
        name: "Juno I Cafe & Wellness space",
        coordinates: [51.55736, -0.01136],
        distances: [6, 2, 2]
      },
      {
        name: "Deeney's",
        coordinates: [51.56216, -0.01029],
        distances: [5, 2, 2]
      },
      {
        name: "Turning Earth Leyton",
        coordinates: [51.57049, -0.03927],
        distances: [30, 10, 27]
      },
      {
        name: "Lighthaus cafe",
        coordinates: [51.57012, -0.03923],
        distances: [34, 10, 27]
      },
      {
        name: "Neckstamper Brewery and Taproom",
        coordinates: [51.56927, -0.03783],
        distances: [32, 9, 27]
      },
      {
        name: "Plykea",
        coordinates: [51.56477, -0.03416],
        distances: [30, 9, 30]
      },
      {
        name: "Sova Audio",
        coordinates: [51.56471, -0.03388],
        distances: [30, 9, 30]
      },
      {
        name: "Pretty Decent Beer Co",
        coordinates: [51.55657, 0.01769],
        distances: [36, 12, 23]
      },
      {
        name: "Westfield Stratford City",
        coordinates: [51.54403, -0.0053],
        distances: [27, 10, 14]
      },
      {
        name: "Gravity Well Brewing Company",
        coordinates: [51.56977, -0.00779],
        distances: [17, 6, 11]
      },
      {
        name: "Marmelo Kitchen",
        coordinates: [51.56395, -0.00585],
        distances: [11, 4, 5]
      },
      {
        name: "Strange Brew e10",
        coordinates: [51.56425, -0.00627],
        distances: [11, 4, 5]
      },
      {
        name: "Leyton Technical Pub",
        coordinates: [51.55868, -0.00751],
        distances: [8, 3, 2]
      },
      {
        name: "Yardarm",
        coordinates: [51.5644, -0.00693],
        distances: [12, 4, 4]
      },
      {
        name: "Cafe Nomadica",
        coordinates: [51.5642, -0.0067],
        distances: [11, 4, 4]
      },
      {
        name: "Coronation Garden's Saturday Market",
        coordinates: [51.55982, -0.01043],
        distances: [3, 1, 1]
      },
      {
        name: "Northcote Arms E11",
        coordinates: [51.56022, -0.00165],
        distances: [14, 5, 9]
      },
      {
        name: "Asda Leyton Mills Superstore",
        coordinates: [51.5559, -0.00936]
      },
      {
        name: "Lyton Mills Retail Park",
        coordinates: [51.55542, -0.00917],
        distances: [11, 4, 8]
      },
      {
        name: "Wild Goose Bakery - Forest Gate Arches",
        coordinates: [51.55395, 0.02059],
        distances: [41, 13, 24]
      },
      {
        name: "Luna - The home of live music",
        coordinates: [51.56825, 0.01041],
        distances: [29, 11, 16]
      },
      {
        name: "All You Read is Love",
        coordinates: [51.57042, 0.01403],
        distances: [34, 12, 21]
      }
    ]
  },
  {
    name: "Transport",
    color: "#1d3e94",
    icon: transportIcon,
    smallIcon: transportSmallIcon,
    largeIcon: transportLargeIcon,
    locations: [
      {
        name: "Leyton Underground",
        line: ["central"],
        coordinates: [51.55652, -0.00562],
        distances: [11, 4, 8]
      },
      {
        name: "Lea Bridge Station",
        line: ["anglia"],

        coordinates: [51.56599, -0.03675],
        distances: [27, 8, 7]
      },
      {
        name: "Leyton Midland Road",
        line: ["overground"],
        coordinates: [51.56946, -0.00731],
        distances: [17, 5, 9]
      },
      {
        name: "Leytonstone High Road",
        line: ["overground"],
        coordinates: [51.56357, 0.00829],
        distances: [27, 9, 14]
      },
      {
        name: "Leytonstone Underground",
        line: ["central"],
        coordinates: [51.56825, 0.00852],
        distances: [27, 10, 15]
      },
      {
        name: "Stratford",
        line: [
          "central",
          "overground",
          "dlr",
          "c2c",
          "tflrail",
          "jubilee",
          "anglia"
        ],
        coordinates: [51.54718, -0.00813],
        distances: [36, 11, 16]
      }
    ]
  },
  {
    name: "Education",
    color: "#1d3e94",
    icon: schoolsIcon,
    smallIcon: schoolsSmallIcon,
    largeIcon: schoolsLargeIcon,
    locations: [
      {
        name: "Newport School",
        coordinates: [51.56418805466714, -0.0028716209314010805],
        distances: [14, 6, 5]
      },
      {
        name: "Dawlish Primary School",
        coordinates: [51.56512894801424, -0.009186261403429645],
        distances: [12, 5, 4]
      },
      {
        name: "Noor Ul Islam Primary School",
        coordinates: [51.5630277211949, -0.006171487550800278],
        distances: [10, 4, 3]
      },
      {
        name: "Lantern of Knowledge Secondary School",
        coordinates: [51.5643576078384, -0.00939483256703052],
        distances: [9, 3, 3]
      },
      {
        name: "Lammas School and Sixth Form",
        coordinates: [51.56544877932782, -0.026829586529680063],
        distances: [18, 6, 10]
      },
      {
        name: "St Joseph's Catholic Infant School",
        coordinates: [51.565065120935195, -0.022636976749183326],
        distances: [12, 4, 6]
      },
      {
        name: "St Joseph's Catholic Junior School",
        coordinates: [51.56852373593733, -0.01609298791809052],
        distances: [15, 4, 5]
      },
      {
        name: "Willow Brook Primary School Academy",
        coordinates: [51.56598886738643, -0.021133168283226422],
        distances: [11, 3, 5]
      },
      {
        name: "Downsell Primary School",
        coordinates: [51.566001302932754, -0.02112534420255591],
        distances: [22, 7, 6]
      },
      {
        name: "Sybourn Primary School",
        coordinates: [51.570615622315614, -0.02668337403813431],
        distances: [24, 8, 7]
      },
      {
        name: "St Saviour's Church of England Primary School",
        coordinates: [51.57375890263742, -0.03003054837868062],
        distances: [26, 9, 15]
      },
      {
        name: "Connaught School for Girls",
        coordinates: [51.566323675831114, 0.005137367507894491],
        distances: [23, 7, 8]
      },
      {
        name: "George Tomlinson Primary School",
        coordinates: [51.56636763402516, 0.008666269288135403],
        distances: [29, 9, 13]
      },
      {
        name: "Acacia Nursery",
        coordinates: [51.55951000951431, 0.01113151161500113],
        distances: [28, 9, 10]
      },
      {
        name: "The Jenny Hammond Primary School",
        coordinates: [51.55511020433204, 0.008356459507174832],
        distances: [28, 9, 10]
      }
    ]
  }
]

export default categories
